import * as React from 'react';
import { useModal } from '../Context/Context';
import S from './Background.styles';
const Background = () => {
    const modal = useModal();
    return (React.createElement(S.Background, { "data-close": modal.closeOnBackground, "aria-hidden": true, onClick: modal.closeOnBackground
            ? (event) => {
                event.preventDefault();
                if (modal.onClose) {
                    modal.onClose();
                }
            }
            : undefined }));
};
export default Background;
